import { atom } from 'recoil';
import { type CallMeVariant } from '../types/opcTypes';
import { callMeVariantOpcSelector } from '../selectors/callMeVariantOpcSelector';

export const callMeVariantOpcAtom = atom<CallMeVariant>({
    key: 'callMeVariantOpcAtom',
    default: callMeVariantOpcSelector
});
